export default __webpack_public_path__ + "static/media/searchByOptionSpace.8307e450.png";